import CheckIcon from "@mui/icons-material/Check";
import { Grid, useTheme } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import Link from "@mui/material/Link";
import React from "react";

export const AttentionBadge = ({
	title,
	count,
	readOnly,
	url,
}: {
	title: string;
	count: number | string;
	readOnly: boolean;
	url: string;
}) => {
	const theme = useTheme();
	const getColor = (count: number | string): string => {
		if (typeof count === "number" && count <= 0) return theme.palette.success.light;
		if (count === "*") return theme.palette.info.light;
		return theme.status.lighterError;
	};

	const getContent = (count: number | string): React.ReactNode => {
		if (count === 0) return <CheckIcon data-component="attention-check-icon" />;
		else if (count === "*")
			return (
				<CircularProgress
					data-component="attention-spinner"
					size={24}
					sx={{ color: theme.palette.common.white }}
				/>
			);
		else return count;
	};
	const avatarColor = getColor(count);
	const avatarContent = getContent(count);

	React.useEffect(() => {
		console.debug({ url, count });
	}, [url, count]);

	return (
		<>
			<Grid data-component="attention-title-grid">
				{!readOnly ? (
					<Link
						data-component="attention-title-link"
						style={{ textDecoration: "none" }}
						href={url}
						color="inherit"
					>
						{title}
					</Link>
				) : (
					title
				)}
			</Grid>
			<Grid sx={{ marginLeft: 3 }} data-component="attention-avatar-grid">
				<Avatar
					data-component="attention-badge-avatar"
					variant="circular"
					sx={{
						backgroundColor: avatarColor,
						color: theme.palette.common.white,
						mr: 2,
					}}
				>
					{avatarContent}
				</Avatar>
			</Grid>
		</>
	);
};
